module.exports = __webpack_public_path__ + "images/VisaLogo__66dc9b2bf6a910ce80dff27b92fa01b1.png";